import { PERMISSIONS } from '../../constants';
import list from './ScoringList';
import create from './ScoringCreate';
import show from './ScoringShow';

export default {
  list,
  create,
  show,
  name: 'scorings',
  permissions: [PERMISSIONS.SCORINGS]
};

export { default as ScoringCreate } from './ScoringCreate';
export { default as ScoringList } from './ScoringList';
export { default as ScoringShow } from './ScoringShow';
export { default as CloneScoringButton } from './CloneScoringButton';
export { default as ScoringDisableButton } from './ScoringDisableButton';
